<template>
    <div>
        <div class="pop"  @touchmove.prevent :class="{show:h_visible}">
            <div class="pop-mask" @click="clickCloseDialog()"></div>
            <div class="pop-contain" ref="refpop">
                <div class="hd flex_layout flex_xy_center">
                    <span class="fam">{{ title }}</span>
                    <div  @click="clickCloseDialog()" class="ico_close"><i></i></div>
                </div>
                <div class="bd">
                    <swiper :options="swiperOption" ref="mySwiper">
                        <swiper-slide v-for="(item, index) in kkbgoods" :key="index">
                            <div class="item re flex_layout flex_flexDirection_column flex_y_center">
                                <div class="i0"><img :src="item.show_image_url"></div>
                                <div class="i1 ov flex_layout flex_xy_center">
                                    <span class="fam">{{ item.recharge_value }}</span>
                                    <span class="fam">KK币</span></div>
                                <div class="i2 ov fam" :class="{opacity0:!item.present_value}">
                                    <span>送{{ item.present_value }}KK币</span>
                                </div>
                                <div v-show="item.recharge_good_type != 0" class="i3 ov fam">
                                    <span>限购一次</span>
                                </div>
                                <div @click="clickJumpPay(item)" class="i4 flex_layout flex_xy_center">
                                    <span class="fam">￥{{ item.real_price | filtersFenToYuan }}</span>
                                </div>
                            </div>
                        </swiper-slide>
                    </swiper>
                </div>
                <div class="ft">
                    <div @click="clickJumpRecharge()" class="line1 flex_layout flex_xy_center">
                        <span>KK币余额：{{mykkb}}</span>
                        <span v-show="show_rechargecenter" class="flex_layout flex_xy_center">全部充值档位<i></i></span>
                    </div>
                    <div v-show="mark" class="line2">提醒：{{ mark }}</div>
                </div>
            </div>

            <!-- 收银台组件 -->
            <cashdesk 
                ref="cashdesk"
                :visible.sync="visible_cashdesk"
                :param="param_cashdesk" 
                @payMessage="receiveCashdeskPayMessage"
                @errorMessage="receiveCashdeskErrorMessage"
            />
        </div>
        <!-- loading -->
        <Loading :visible="h_loading"/>
    </div>
</template>

<script>
//npm模块
import 'swiper/dist/css/swiper.css'//这里注意具体看使用的版本是否需要引入样式，以及具体位置。
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import cashdesk from '../../cashdesk/src/cashdesk'
//组件
import Loading from '../../common/Loading'
import slide from "../../../assets/animation/slide";
//公用方法 - 全局
import {
    toast,
    debug,
    ua,
    fenToYuan
} from '@kkmh/utils'

//组件方法 - 局部
import {getPayParam} from "../../../assets/utils";
import {
    getBaseParam,
    getKkbViewData,
    getKkbList,
    jumpToRechargeCenter,
} from "../js/common";
import {
    doTrackPv,
    doTrackClick,
} from "../js/track";
export default {
    components: {
      swiper,
      swiperSlide,
      Loading,
      cashdesk
    },
    name: 'KkbHalfScreen',
    data () {
        return {
            h_loading           : false,
            h_visible           : false,
            swiperOption        : {
                // autoplay: true,//可选选项，自动滑动
                // slidesPerView: 'auto', //5.1,
                slidesPerView: 3.3, //5.1,
                // loopedSlides: 4,
            },
            //收银台参数
            visible_cashdesk    : false,
            param_cashdesk      : {},
            kkbdata             : {},
            j_curgood_info      : {},
            j_req               : {},

        }
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        param:{
            type: Object,
            default: () => {
                return {}
            }
        },
    },
    watch:{
        visible:{
            handler(val){
                if(val) {
                    // 调用者先设置param然后设置visible，setTimeout可以解决此顺序正确赋值
                    setTimeout(() => {
                        this.h_loading = true;
                        this.init();
                        this.notifyResetVisibleFalse();
                    },0);
                }
            },
            deep:true
        },
        param:{
            handler(val){
                this.j_req = JSON.parse(JSON.stringify(val));
            },
            deep:true
        },
    },
    computed: {
        kkbgoods() {
            return this.kkbdata.goods || [];
        },
        title() {
            return this.kkbdata.title || '';
        },
        mykkb() {
            return this.kkbdata.mykkb || 0;
        },
        show_rechargecenter() {
            return this.kkbdata.show || false;
        },
        mark() {
            return this.kkbdata.mark || '';
        },
        swiper() {
            return this.$refs.mySwiper.swiper
        }
    },
    methods:{
        init(){
            (async () => {
                this.j_req = await getBaseParam(this.j_req);
                let issuccess = await this.getViewData();
                if (issuccess) {
                    this.openDialog();    
                }
            })();
        },
        async getViewData(){
            let {code, data, message} = await getKkbViewData(this.j_req);
            if (code !== 200) {
                this.notifyErrorMessage(code, message, data);
                return false;
            }
            this.kkbdata = data || {};
            //初始化
            this.initSwiper();
            return true;
        },
        initSwiper(){
            this.$nextTick(() => {
                if (this.swiper.slides.length) {
                    this.swiper.update();
                    this.swiper.slideTo(0, 1000, false);
                    return null;    
                }
            });
        },
        clickCloseDialog(){
            this.closeDialog();
        },
        //跳转充值中心
        clickJumpRecharge() {
            jumpToRechargeCenter(this.j_req, (res, nativecallback_name) => {
                let {data={}} = res;
                if (data.curr_page_is_visible == 0) {
                    this.notifyRechargeCenterOpen();
                }
                if (data.curr_page_is_visible == 1) {
                    this.notifyRechargeCenterClose();
                    if (nativecallback_name) {
                        delete window[nativecallback_name] //释放内存    
                    }
                }
            })
        },
        // 支付商品
        clickJumpPay(item) {
            doTrackClick('充值￥'+fenToYuan(item.real_price,2), this.j_req);
            this.j_curgood_info = item;
            this.param_cashdesk = getPayParam({
                ...this.j_req,                    
                good_id : item.id,  //必须-int 76
            });
            this.visible_cashdesk = true;
        },
        // 开启-半屏
        openDialog(){
            this.h_loading = false;
            this.h_visible = true;
            this.$nextTick(() => {
                slide.up(this.$refs.refpop, () => {
                    doTrackPv(this.j_req);
                });
            })
            this.notifyDialogOpen();
        },
        // 关闭-半屏
        closeDialog(){
            slide.down(this.$refs.refpop);
            setTimeout(() => {
                this.h_visible = false;//关闭时为了有slide效果
            },300)
            this.notifyDialogClose();
        },
        // 收银台组件-接收 : 收银台操作
        receiveCashdeskPayMessage(res){
            res.data.good_info = this.j_curgood_info;
            if(res.data.pay_status == 1) {
                this.getViewData();//需要更新swiper
            }
            this.notifyPayMessage(res);
        },
        // 收银台组件-接收 : 出错
        receiveCashdeskErrorMessage({code=0, message='', data={}} = {}){
            this.notifyErrorMessage(code, message, data);
        },
        // kkb半屏组件-通知 : 拉起
        notifyDialogOpen(){
            debug(`【kkb半屏 - 拉起】`);
            this.$emit('dialogOpen');
        },
        // kkb半屏组件-通知 : 关闭
        notifyDialogClose(){
            debug(`【kkb半屏 - 关闭】`);
            this.$emit('dialogClose');
        },
        // kkb半屏组件-通知 : 跳转充值中心
        notifyRechargeCenterOpen(){
            debug(`【kkb半屏 - 跳转充值中心】`);
            this.$emit('rechargeCenterOpen');
        },
        // kkb半屏组件-通知 : 返回充值中心
        notifyRechargeCenterClose(){
            debug(`【kkb半屏 - 返回充值中心】`);
            this.$emit('rechargeCenterClose');
        },
        // kkb半屏组件-通知 : 支付信息
        notifyPayMessage(res){
            debug(`【kkb半屏 - 支付信息】`, res);
            this.$emit('payMessage', res);
        },
        // kkb半屏组件-通知 : 出错
        notifyErrorMessage(code, message, data={}){
            debug(`【kkb半屏 - 出错信息】`);
            this.h_loading = false;
            let info = ua.prod ? `${message}` : `[${code}]-${message}`;
            toast(`拉起遇到问题~ ${info}`);
            this.$emit("errorMessage", {code, data, message});
        },
        // kkb半屏组件-通知 : 更新visible重制才能重新点击打开
        notifyResetVisibleFalse(){
            // debug(`【kkb半屏 - 重制visible】`);
            this.$emit('update:visible', false);
        },
        // kkb半屏组件-通知 : 商品列表信息 kkb （父组件通过ref可以调用）
        getListData(){
            setTimeout(() => {
                (async () => {
                    let opt = await getBaseParam(this.j_req);
                    let res = await getKkbList(opt);
                    debug(`【收银台 - 商品列表信息】`,res);
                    this.$emit('listData',res);
                })()
            },0);
        },
    },
    filters:{
        filtersFenToYuan(v){
            return fenToYuan(v,2);
        }
    }
}
</script>


<style>
.fam{font-family: -apple-system, BlinkMacSystemFont, "PingFang SC","Helvetica Neue",STHeiti,"Microsoft Yahei",Tahoma,Simsun,sans-serif;}
</style>
<style lang="scss" scoped>
@import "../../../assets/styles/flex.css";
@import "../../../assets/styles/mixins.scss";
*{padding: 0;margin: 0;box-sizing: border-box;}
ul,li,dl,ol {list-style: none; }
em,i {font-style: normal; }
img {width: 100%;vertical-align: middle;border: none;}
a, img {-webkit-touch-callout: none; pointer-events: none;/* 禁止长按链接与图片弹出菜单 */}
.opacity0{opacity:0;}
.re{position:relative}

.pop.show{display:block;}
.pop{
    display:none;z-index:998;position: fixed;left:0;top:0;height:100%;width:100%;overflow: hidden;
    .pop-mask{
        position: absolute;left:0;top:0;height:100%;width:100%;overflow: hidden;background: rgba(0,0,0,.5);
    }
    .pop-mask.transparentbg{
        background: rgba(0,0,0,0);
    }
    .pop-contain{
        transform: translate3d(0,100%,0);
        border-radius: vws(10px) vws(10px) 0 0;
        position: absolute;left:0;bottom:0;width:100%;font-size: vws(24px);color:#000;background: #fff;
        .hd{
            position:relative;padding:vws(60px) 0;
            span{font-family: PingFangSC-Medium;font-weight:bold;font-size: vws(34px);color: #000000;}
            .ico_close{
                position: absolute;right: vws(8px);top: 48%;transform: translateY(-50%);
                i{display:block;width:vws(66px);height:vws(66px);background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEIAAABCBAMAAAAReh3bAAAAG1BMVEUAAAA0NDQ0NDQ0NDQ0NDQ1NTU3Nzc0NDQzMzOq3yguAAAACHRSTlMA7jG2nEMOWMqgP5oAAACFSURBVEjH7ZM9CoAwDEZLQQ/goB0tXkTwZA5Cjy2EkizhDZ065JtKebz+JEmRyEx5TltftwMsbdN1Lp9DrOVVSW17clJVkhXW2L6xIOkoSYQESQdJIhxIOkYSUZDkEAVJmihQAgog4BS8Kb926Mf417lyXH3uoIEu5E7maeCJ4qmMRObJDzogJmMdxHv/AAAAAElFTkSuQmCC") no-repeat 0 0;background-size: 100% 100%;}
            }
        }
        .bd{
            padding-left:vws(32px);
            .item{
                width:vws(206px);
                height:vws(228px);
                border: 1px solid #F2F2F2;
                border-radius: vws(10px);
                padding-top:vws(54px);
                .ov{
                    white-space: nowrap;
                    overflow: hidden;
                    width: 100%;
                }
                .i0{
                    position:absolute;
                    left:-1px;
                    top:0;
                    width: vws(206px);
                    height:vws(34px);
                    overflow:hidden;
                    border-radius: vws(8px) vws(8px) 0 0;
                }
                .i1{
                    span:first-child{font-size: vws(40px);color: #000000;padding-right:vws(4px);font-weight: 500;font-family: PingFangSC-Semibold;}
                    span:last-child{font-size: vws(24px);color: #000000;font-family: PingFangSC-Regular;}
                }
                .i2{
                    position:absolute;
                    left:0;
                    top:vws(98px);
                    width:100%;
                    text-align:center;
                    font-size:vws(24px);color: #FF751A;transform:scale(.8);transform-origin:center center;
                    font-family: PingFangSC-Medium;}
                .i3{
                    position:absolute;
                    left:0;
                    top:vws(124px);
                    width:100%;
                    text-align:center;
                    font-size:vws(24px);color: #E6E6E6;transform:scale(.8);transform-origin:center center;
                    font-family: PingFangSC-Medium;}
                .i4{
                    position:absolute;
                    left:50%;
                    bottom:vws(20px);
                    transform:translateX(-50%);
                    background: #FF751A;
                    border-radius: vws(24px);
                    width:vws(166px);
                    height:vws(48px);
                    span{font-size:vws(24px);color:#ffffff;
                    font-family: PingFangSC-Medium;}
                }
            }
        }
        .ft{
            padding:vws(64px) 0 vws(78px);
            .line1{
                font-size:vws(24px);
                color:#000;
                span:first-child{padding-right:vws(26px);font-family: PingFangSC-Medium;font-weight:500;}
                span:last-child{
                    color: #FF751A;text-decoration:underline;font-family: PingFangSC-Regular;
                    i{display:block;width:vws(26px);height:vws(26px);background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeBAMAAADJHrORAAAAG1BMVEUAAAD/dyL/dRr/dRv/dyL/dRr/dhv/dRr/dRpeI+qUAAAACHRSTlMAHt7ID9XFuaZGpNkAAAAvSURBVBjTYxh4kCoAQghQoQhCCODcJABECD6LhSIQUa4AnY+hnnJphH8w/EsnAABlXBKR3zT/GwAAAABJRU5ErkJggg==") no-repeat 0 0;background-size: 100% 100%;}
                }
            }
            .line2{font-family: PingFangSC-Regular;margin-top:vws(8px);text-align:center;font-size:vws(24px);color: #CBCBCB;transform:scale(.8);transform-origin:center center;}
        }
    }
}

.slideon {
    animation: slideUp .2s 0s linear both;
}
.slideoff {
    animation: slideDown .2s 0s linear both;
}

@keyframes slideUp {
    100% {
        transform: translate3d(0,0,0);
    }
}

@keyframes slideDown {
    0% {
        transform: translate3d(0,0,0);
    }
    100% {
        transform: translate3d(0,100%,0);
    }
}

</style>







// WEBPACK FOOTER //
// node_modules/@kkmh/pays/src/components/kkbhalfscreen/src/kkbhalfscreen.vue